import { render, staticRenderFns } from "./ClaimEdit.vue?vue&type=template&id=4d3c0dee&scoped=true&"
import script from "./ClaimEdit.vue?vue&type=script&lang=js&"
export * from "./ClaimEdit.vue?vue&type=script&lang=js&"
import style0 from "./ClaimEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ClaimEdit.vue?vue&type=style&index=1&id=4d3c0dee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3c0dee",
  null
  
)

export default component.exports